import Vue from "vue";
import App from "./App.vue";
import "leaflet/dist/leaflet.css";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/analytics";
import "firebase/performance";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyDwLIORKHlPjGD_v-7t_swUu7E2wafdxLA",
  authDomain: "device-tracking-5e5a4.firebaseapp.com",
  databaseURL: "https://device-tracking-5e5a4.firebaseio.com",
  projectId: "device-tracking-5e5a4",
  storageBucket: "device-tracking-5e5a4.appspot.com",
  messagingSenderId: "639355628140",
  appId: "1:639355628140:web:e2fbce2d4c6bee7c61c649",
  measurementId: "G-PPWKX2Z54N"
};

if (typeof window !== "undefined" && !firebase.apps.length) {
  window.firebase = firebase;
  firebase.initializeApp(config);
  if ("measurementId" in config) {
    firebase.analytics();
    firebase
      .analytics()
      .logEvent("App Started at: " + new Date().toISOString());
  }
}

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
